const ShinyText = ({ text, disabled = false, speed = 5, className = '', as = 'h1' }) => {
  const Component = as;
  return (
    <Component
      className={`relative inline-block overflow-hidden ${className}`}
    >
      {text}
      {!disabled && (
        <span
          className="absolute inset-0 animate-shine"
          style={{
            background: `linear-gradient(105deg, transparent 40%, rgba(200, 170, 255, 0.35) 50%, transparent 60%)`,
            backgroundSize: '200% 100%',
            animationDuration: `${speed}s`,
            mixBlendMode: 'screen',
          }}
        />
      )}
    </Component>
  );
};

export default ShinyText;